import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  chooseBrandsMobileSearchEmail,
  chooseBrandsAndroidMobileSearchEmail,
  chooseBrandsProprietaryMobileSearchEmail,
  choosePhoneCameraMobileSearchEmail,
  choosePhoneFromListMobileSearchEmail,
  choosePhoneMemoryMobileSearchEmail,
  choosePhoneOsMobileSearchEmail,
  choosePhoneSizeMobileSearchEmail,
  currentProviderMobileMobileSearchEmail,
  howManyCallingMinutesMobileSearchEmail,
  howMuchDataMobileSearchEmail,
  provincesStepMobileSearchEmail,
  buyOrBringPhoneMobileSearchEmail,
  emailAddressMobileSearchEmail,
} from './mobile-search-email-steps'

export const mobileSearchEmailScenarioA: Scenario = {
  id: 'mobile-search-email-a',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE_SEARCH_EMAIL,
  version: '1',
  milestones: [
    provincesStepMobileSearchEmail.id,
    currentProviderMobileMobileSearchEmail.id,
    howManyCallingMinutesMobileSearchEmail.id,
    howMuchDataMobileSearchEmail.id,
    buyOrBringPhoneMobileSearchEmail.id,
    choosePhoneOsMobileSearchEmail.id,
    chooseBrandsMobileSearchEmail.id,
    choosePhoneSizeMobileSearchEmail.id,
    choosePhoneCameraMobileSearchEmail.id,
    choosePhoneMemoryMobileSearchEmail.id,
    choosePhoneFromListMobileSearchEmail.id,
    emailAddressMobileSearchEmail.id,
  ],
  steps: [
    provincesStepMobileSearchEmail,
    currentProviderMobileMobileSearchEmail,
    howManyCallingMinutesMobileSearchEmail,
    howMuchDataMobileSearchEmail,
    buyOrBringPhoneMobileSearchEmail,
    choosePhoneOsMobileSearchEmail,
    chooseBrandsMobileSearchEmail,
    chooseBrandsAndroidMobileSearchEmail,
    chooseBrandsProprietaryMobileSearchEmail,
    choosePhoneSizeMobileSearchEmail,
    choosePhoneCameraMobileSearchEmail,
    choosePhoneMemoryMobileSearchEmail,
    choosePhoneFromListMobileSearchEmail,
    emailAddressMobileSearchEmail,
  ],
}
